import Vue from "vue";
import vuexStoreBuilder, { strings } from "vuex-store-builder";
import {
  getAllTypes,
  getAllRecordRootNodes,
  getAllUoms,
  getAllGlossarys,
  getAllCatRootNodes,
  getAllTemplateRootNodes,
  createCat,
  mergeCatToRecord,
  createTemplateFromRecord,
  createRecordFromTemplate,
  createRecord,
  deleteRecordTree,
  createUom,
  updateRecordNode,
  getAnalysisCategories,
  getStateId,
  fetchCommonalities,
  getOrdersForRecord,
} from "../utils/api";

export const getId = ({ _id }) => _id;
export const handleData = (state, response, params, slug) => {
  Vue.set(state, "byId", {});
  if (Array.isArray(response)) {
    response.forEach((datum) => Vue.set(state.byId, getId(datum), datum));
  } else {
    Vue.set(state.byId, getId(response), response);
  }
  state[strings.loaded(slug)] = true;
};

/*
 * These should also be added to webbrowser/src/store/index.js so they are seen by the rest of the codebase.
 */
export const allTypes = vuexStoreBuilder("types", getAllTypes, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "types");
  },
});
export const allUoms = vuexStoreBuilder("uoms", getAllUoms, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "uoms");
  },
  mutations: {
    updateUoms(state, datum) {
      Vue.set(state.byId, getId(datum), datum);
    },
  },
});
export const allGlossaries = vuexStoreBuilder("glossaries", getAllGlossarys, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "glossaries");
  },
});
export const allRootNodes = vuexStoreBuilder("nodes", getAllRecordRootNodes, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "nodes");
  },
});
export const allTemplates = vuexStoreBuilder(
  "templates",
  getAllTemplateRootNodes,
  {
    getKey: getId,
    receive(state, { response, params }) {
      handleData(state, response, params, "templates");
    },
  }
);
export const allRootCats = vuexStoreBuilder("cats", getAllCatRootNodes, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "cats");
  },
  mutations: {
    updateCats(state, datum) {
      Vue.set(state.byId, getId(datum), datum);
    },
  },
});
export const postNewCategory = vuexStoreBuilder("createCat", createCat, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "createCat");
  },
});
export const addCatToRecord = vuexStoreBuilder("mergeCat", mergeCatToRecord, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "mergeCat");
  },
});
export const createTemplate = vuexStoreBuilder(
  "createTemplate",
  createTemplateFromRecord,
  {
    getKey: getId,
    receive(state, { response, params }) {
      handleData(state, response, params, "createTemplate");
    },
  }
);
export const cloneRecordFromTemplate = vuexStoreBuilder(
  "createRecordFromTemplate",
  createRecordFromTemplate,
  {
    getKey: getId,
    receive(state, { response, params }) {
      handleData(state, response, params, "createRecordFromTemplate");
    },
  }
);
export const postNewRecord = vuexStoreBuilder("createRecord", createRecord, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "createRecord");
  },
  mutations: {
    updateRecs(state, datum) {
      Vue.set(state.byId, getId(datum), datum);
    },
  },
});
export const removeNode = vuexStoreBuilder("deleteNode", deleteRecordTree, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "node");
  },
});
export const postNewUom = vuexStoreBuilder("createUom", createUom, {
  getKey: getId,
  receive(state, { response, params }) {
    handleData(state, response, params, "uoms");
  },
});

export const updateRecNode = vuexStoreBuilder(
  "updateRecordNode",
  updateRecordNode,
  {
    getKey: getId,
    receive(state, { response, params }) {
      handleData(state, response, params, "node");
    },
  }
);

export const cdgGetAnalysisCats = vuexStoreBuilder(
  "getAnalysisCategories",
  getAnalysisCategories,
  {
    getKey: (id) => id,
    receive(state, { response, params }) {
      Vue.set(state, "byId", {});
      response.forEach((datum, index) => Vue.set(state.byId, index, datum));
      state[strings.loaded("getAnalysisCategories")] = true;
    },
  }
);

export const cdgGetStateId = vuexStoreBuilder("getStateId", getStateId, {
  getKey: (id) => id,
  state: { failed: false, failedError: "" },
  receive(state, { response }) {
    if (response.state_id) {
      Vue.set(state, "stateId", response.state_id);
      state[strings.loaded("getStateId")] = true;
    } else {
      state[strings.failed("getStateId")] = true;
    }
  },
  fail(state, error) {
    state.failed = true;
    state.failedError = error;
  },
});

export const cdgFetchCommonalities = vuexStoreBuilder(
  "fetchCommonalities",
  fetchCommonalities,
  {
    getKey: ({ stateId }) => stateId,
    receive(state, { response }) {
      if (!Array.isArray(state.byId[response.analysis.stateId])) {
        Vue.set(state.byId, response.analysis.stateId, []);
      }
      Vue.set(
        state.byId[response.analysis.stateId],
        response.analysis.sampleSize,
        response.analysis
      );
      state[strings.loaded("fetchCommonalities")] = true;
    },
  }
);
export const allOrdersFromRecord = vuexStoreBuilder(
  "orders",
  getOrdersForRecord,
  {
    getKey: getId,
    receive(state, { response, params }) {
      handleData(state, response, params, "orders");
    },
  }
);
